import React, { useCallback, useContext, useEffect } from 'react'
import { Tabs } from 'components'
import { assessmentsHooks, AssessmentTable } from '.'
import { initialPage } from 'keys/pagination'
import { AssessmentsContext, tableViewTypes } from './AssessmentsContext'
import { LightButton } from 'styles/GlobalStyle'
import { keyBy } from 'lodash'
import { Can } from 'components/Permissions'

const AssessmentTableTabs = () => {
    const { setSelectedAssessments, setIsAssignAssessmentAlertOpen, showActionBtns, setShowActionBtns, setIsAssignAssessmentAlert2Open, deleteAssessmentsAlertOpen, setDeleteAssessmentsAlertOpen, setSorting, initialTableView, setTableView, tableView, setRowOpen, selectedAssessments, setOpenStatusAlert, setOpenCreateBatteryAlert, setOpenDuplicateAlert, setShowQuestionAssessments } = useContext(AssessmentsContext)
    const tabs = assessmentsHooks.useTabs()
    const tabKeys = keyBy(tabs, 'type')

    const currentTab = tabKeys[tableView]

    const handleTab = (index) => {
        setTableView(index ? tableViewTypes.single : tableViewTypes.battery)
        currentTab.setPage(initialPage)
        setSelectedAssessments(null)
        setRowOpen(null)
        setSorting([])
    }

    const showAllAssessments = useCallback(() => {
        setShowQuestionAssessments(true)
    }, [])

    useEffect(() => {
        return (() => {
            setTableView(initialTableView)
        })
    }, [])

    return (
        <div className='assessment-tabs-and-table'>
            <div className='wrap-tab-header'>
                <Tabs tabs={tabs} handleTab={handleTab} />
                <Can I="manage" a="super-user">
                    <div className='btn-actions'>
                        <LightButton
                            variant="solid"
                            role="create"
                            permissionHOC="hidden"
                            size="small"
                            feature="battery"
                            label={showActionBtns ? "הסתר" : "הצג פעולות"}
                            action={() => setShowActionBtns(show => !show)}
                        />
                        {showActionBtns &&
                            currentTab.actionBtns?.map((actionBtn) =>
                                <LightButton
                                    variant="solid"
                                    role="create"
                                    permissionHOC="hidden"
                                    size="small"
                                    feature="battery"
                                    label={actionBtn.label}
                                    action={actionBtn.action}
                                />
                            )
                        }
                    </div>
                </Can>
            </div >
            <div className='wrap-table'>
                <AssessmentTable
                    withTabs
                    {...currentTab}
                />
            </div>
        </div >
    )
}
export default AssessmentTableTabs